import { Platform } from '@/types/platform'

const awardsSectionIdMap = new Map<Platform, number>([
  [Platform.goodhouse, 1025],
])

const brandsSectionIdMap = new Map<Platform, number>([
  [Platform.cosmo, 435],
  [Platform.goodhouse, 1007],
])

const sonnykTypeSectionId = 41

// TODO: Переделать и забирать данные из API
const beautySectionIdMap = new Map<Platform, number>([[Platform.cosmo, 469]])
const trendsAutoIdMap = new Map<Platform, number>([[Platform.mhealth, 101003]])

const fashionSectionIdMap = new Map<Platform, number>([[Platform.cosmo, 437]])

export {
  beautySectionIdMap,
  awardsSectionIdMap,
  brandsSectionIdMap,
  fashionSectionIdMap,
  sonnykTypeSectionId,
  trendsAutoIdMap,
}
